<markant-card *ngIf="cartridgeRoles" class="service-card" outlined="true">
  <div slot="markant-card__headline" class="card-header">
    <h6 class="cartridge-name">
      {{ cartridgeRoles.name }}
    </h6>

    @if (isRoleLimitEnabled) {
      <markant-platform-ui-cartridge-role-limit
        [cartridgeRole]="cartridgeRoles"
        [flow]="flow"
      >
      </markant-platform-ui-cartridge-role-limit>
    }
  </div>
  <ul class="service-card-content" slot="markant-card__content">
    @for (role of cartridgeRoles.roles; track role.cartridgeVariantId) {
      <li>
        <markant-platform-ui-cartridge-roles-assignment-role
          [attr.data-cy]="'role-' + role.id"
          [id]="role.id"
          [name]="role.localizedDisplayName"
          [disabled]="
            flow === CartridgeRoleAssignmentFlow.Add &&
            ((role.selected ?? false) ||
              !cartridgeRoles.limits?.allowsAssignment)
          "
          [clickable]="
            !role.selected &&
            flow === CartridgeRoleAssignmentFlow.Add &&
            !!cartridgeRoles.limits?.allowsAssignment
          "
          [isPreview]="flow === CartridgeRoleAssignmentFlow.Preview"
          (keydown.enter)="onRoleCardClick(role)"
          (clicked)="onRoleCardClick(role)"
        >
          <section role-actions>
            @if (flow === CartridgeRoleAssignmentFlow.Add) {
              <markant-icon
                icon="m_plus-small"
                class="service-role-add"
              ></markant-icon>
            } @else if (flow === CartridgeRoleAssignmentFlow.Preview) {
              <markant-icon
                icon="m_trash"
                class="service-role-preview"
                clickable="true"
                colorScheme="primary"
                data-cy="remove-role-button"
                (keydown.enter)="onRemoveClick(role)"
                (click)="onRemoveClick(role)"
              >
              </markant-icon>
            }
          </section>
          <section role-details>
            <div
              class="role-card-content"
              [class.readonly-with-suborg]="
                flow === CartridgeRoleAssignmentFlow.ReadOnly &&
                role.suborganizationData?.length
              "
              *ngIf="
                (flow === CartridgeRoleAssignmentFlow.Preview &&
                  hasSuborganizations) ||
                (flow === CartridgeRoleAssignmentFlow.ReadOnly &&
                  role.suborganizationData?.length)
              "
            >
              <span class="service-role-responsibility-label">{{
                'cartridge.roles.assignment.responsibleFor' | transloco
              }}</span>
              <div *ngIf="!role.suborganizationData?.length">
                <markant-card
                  outlined="true"
                  class="selected-suborganizations-card"
                >
                  <div
                    slot="markant-card__content"
                    class="selected-suborganizations-card-content"
                  >
                    <span class="suborganization-name">{{
                      'cartridge.roles.assignment.allLocations' | transloco
                    }}</span>
                  </div>
                </markant-card>
              </div>
              <div
                *ngIf="role.suborganizationData"
                class="suborganizations-container"
              >
                @for (suborga of role.suborganizationData; track suborga.id) {
                  <markant-card
                    outlined="true"
                    class="selected-suborganizations-card"
                  >
                    <div
                      slot="markant-card__content"
                      class="selected-suborganizations-card-content"
                    >
                      <span class="suborganization-name">{{
                        suborga.name
                      }}</span>
                    </div>
                  </markant-card>
                }
              </div>
              @if (flow !== CartridgeRoleAssignmentFlow.ReadOnly) {
                <div class="location-actions-container">
                  <markant-button
                    colorScheme="primary"
                    variant="clear"
                    data-cy="edit-suborganizations-button"
                    (keydown.enter)="onEditSuborganizationClick(role)"
                    (click)="onEditSuborganizationClick(role)"
                  >
                    {{ 'cartridge.roles.assignment.editLocations' | transloco }}
                  </markant-button>
                </div>
              }
            </div>
          </section>
        </markant-platform-ui-cartridge-roles-assignment-role>
      </li>
    }
  </ul>
</markant-card>
